// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"831e5fe4","239":"e53adb27","453":"80cd8578","455":"cd2827cc"}[chunkId] + ".chunk.js";
};